import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mga-report-list-filter__horizontal-block-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ListFilterPopover = _resolveComponent("ListFilterPopover")!

  return (_openBlock(), _createBlock(_component_ListFilterPopover, {
    "is-filter-visible": _ctx.isFilterVisible,
    "is-filter-active": _ctx.isFilterActive,
    "is-filter-loading": _ctx.isReportListLoading,
    onCloseFilter: _ctx.closeFilter,
    onSubmitFilter: _ctx.submitFilter,
    onResetFilter: _ctx.resetFilter
  }, {
    "filter-content": _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "mgaReportListFilterFormRef",
        model: _ctx.filterFormData,
        "label-position": "top",
        class: "mga-report-list-filter"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Group by",
            class: "mga-report-list-filter__item",
            prop: _ctx.ReportListFilterFields.GROUP_BY_DATE
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterFormData.groupByDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterFormData.groupByDate) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.GROUP_BY_OPTIONS, ({ value, label }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: value,
                      class: "mga-report-list-filter__item",
                      label: label,
                      value: value
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"]),
          _createVNode(_component_el_form_item, {
            label: "Country",
            class: "mga-report-list-filter__item",
            prop: _ctx.ReportListFilterFields.COUNTRY
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterFormData.country,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterFormData.country) = $event)),
                loading: _ctx.isCountryListLoading,
                placeholder: "Select country",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryList, ({ code, name }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: code,
                      class: "mga-report-list-filter__item",
                      label: name,
                      value: code
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "loading"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"]),
          _createVNode(_component_el_form_item, {
            label: "Currency",
            class: "mga-report-list-filter__item",
            prop: _ctx.ReportListFilterFields.CURRENCY
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterFormData.currency,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterFormData.currency) = $event)),
                loading: _ctx.isCurrencyListLoading,
                placeholder: "Select currency",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencyList, ({ code }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: code,
                      class: "mga-report-list-filter__item",
                      label: code,
                      value: code
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "loading"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"]),
          _createVNode(_component_el_form_item, {
            class: "mga-report-list-filter__item",
            label: "Game producer ID",
            prop: _ctx.ReportListFilterFields.GAME_PRODUCER_ID
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.filterFormData.gameProducerId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterFormData.gameProducerId) = $event)),
                clearable: "",
                placeholder: "Enter game producer ID"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"]),
          _createVNode(_component_el_form_item, {
            label: "Game Type",
            class: "mga-report-list-filter__item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterFormData.gameType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterFormData.gameType) = $event)),
                loading: _ctx.isGameTypeListLoading,
                clearable: "",
                placeholder: "Select game type"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameTypeList, ({ label, value }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: value,
                      label: label,
                      value: value
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "loading"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            class: "mga-report-list-filter__item",
            label: "Game category",
            prop: _ctx.ReportListFilterFields.GAME_CATEGORY
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterFormData.gameCategory,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterFormData.gameCategory) = $event)),
                loading: _ctx.isGameCategoryListLoading,
                placeholder: "Select game category",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameCategoryList, ({ gameCategoryId, slug }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: gameCategoryId,
                      label: slug,
                      value: gameCategoryId
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "loading"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_form_item, {
              class: "mga-report-list-filter__item",
              label: "From",
              prop: _ctx.ReportListFilterFields.DATE_FROM
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.filterFormData.dateFrom,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterFormData.dateFrom) = $event)),
                  type: "datetime",
                  placeholder: "Select date and time",
                  clearable: ""
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["prop"]),
            _createVNode(_component_el_form_item, {
              class: "mga-report-list-filter__item",
              label: "To",
              prop: _ctx.ReportListFilterFields.DATE_TO
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.filterFormData.dateTo,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterFormData.dateTo) = $event)),
                  type: "datetime",
                  placeholder: "Select date and time",
                  clearable: ""
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["prop"])
          ]),
          _createVNode(_component_el_form_item, {
            class: "mga-report-list-filter__item",
            label: "Exchange rate date",
            prop: _ctx.ReportListFilterFields.EXCHANGE_RATE_DATE
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filterFormData.exchangeRateDate,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterFormData.exchangeRateDate) = $event)),
                type: "datetime",
                placeholder: "Select date and time",
                clearable: ""
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["prop"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-filter-visible", "is-filter-active", "is-filter-loading", "onCloseFilter", "onSubmitFilter", "onResetFilter"]))
}